import { configure as mobxConfig } from 'mobx';

mobxConfig({
  enforceActions: 'always',
});
